<div class="h-[82vh] bg-white rounded-xl">
	<app-calendar-filter [screenHeight]="screenHeight" [day]="currentDate.getDate().toString().padStart(2, '0')" [month]="getCurrentMonthStr()" [year]="currentYear" (previewDate)="prevDay()" (nextDate)="nextDay()"/>
	<hr>
	<div class="flex  h-[90%] w-full">
		<div class="w-[55%] pt-3" *ngIf="!isLoading" [ngClass]="{'bg-gray-100 ml-5 overflow-y-hidden':CountVisiblePosts()==0 || noPlatformSelected}">
			<span class="text-[1vw] rounded-lg ml-8 p-1 uppercase sticky" [ngClass]="{'bg-cliking_blue text-white': toDay()}">
				{{getCurrentDayStr()}}
				<span class="font-semibold">
					{{currentDate.getDate().toString().padStart(2, '0')}}
				</span >
			</span>
			<div *ngIf="CountVisiblePosts()==0 || noPlatformSelected" class="relative">
				<!-- if actually no posts on this day -->
				<div  class="flex items-center justify-center ml-5  ">
					<!-- noposts -->
					 
					 <div *ngIf="getNodetailsMessage()=='resteFilters'" class="text-center flex flex-col items-center justify-center gap-4 " style="margin-top: 32%;">
						<div class="font-semibold">{{"posts.noPostsInLibraryfilter" | translate}}</div>
							<span class="font-normal text-sm">{{"posts.noPostsInLibraryfilterDetails" | translate}}</span>
							<a class="text-sm underline text-cliking_blue cursor-pointer" (click)="resetFilters()">
								<span class="flex items-center justify-center gap-1">
									<span>
										{{"posts.clearFilters" | translate}} 
									</span>
									<svg  width="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
								</span>
							</a>
					 </div>

					<div *ngIf="getNodetailsMessage()=='NoData'">
						<div class="text-center flex flex-col items-center justify-center gap-4" style="margin-top: 39%;">
							<div class="font-semibold">{{"posts.noPostsInLibraryData" | translate}}</div>
								<span class="font-normal text-sm" style="width: 472px;">{{"posts.noPostsInLibraryDataDetails" | translate}}</span>
									<button class="text-white font-semibold text-sm bg-cliking_blue rounded-xl p-3 m-3 mt-9" (click)="openPostFactory()">
										{{"generic.CreateAPost" | translate}}
										<span class="ml-2"><i class="fa fa-plus-circle" aria-hidden="true"></i></span>
									</button>
							</div>
						</div>
				</div>
				
			</div>
			<div *ngIf="currentDayPosts.length>0" class="overflow-y-auto h-[85%] ml-4 my-2">
				<div class="ml-4 mr-2 w-[95%]" *ngFor="let post of currentDayPosts ; index as i">
					<div *ngIf="post.isVisible">
						<span class="ml-2 text-base" *ngIf="post.postHour">
						<!-- <span class="ml-2 text-base" *ngIf="post.postHourRange"> -->
							{{post.postHour}}
						</span>
						<div class="w-full mb-1"
							[ngClass]="{
							'border-[2px] p-0 rounded-2xl': clikedPost == i,
							'p-[2px]': clikedPost != i,
							'border-[#1dc9b7] postedShadow': clikedPost == i && post.isPosted,
							'border-[#ffb822] plannedShodow': clikedPost == i && post.isPlanned,
							'border-[#d33f3f] plannedShodow': clikedPost == i && post.isFailed 
							}"
						>
							<app-post-day-label (click)="clickPost(i)" class="cursor-pointer"
								[post]="post"
								[currentGroups]="groupScopes"
								[isSelected]="clikedPost == i"
                (hidedPost)="onHidedPost($event)"
								(updatePostsInDay)="notifyUpdatePostsInDay($event)"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="w-[44%]"  *ngIf="!isLoading " >
			<app-show-post *ngIf=" checkPreviewVisibility()"
			class="w-full max-h-[70vh] block"
			[screenHeight]="screenHeight" [screenWidth]="screenWidth" [posts]="selectedPost"
			/>
		
			<div  *ngIf=" !checkPreviewVisibility()">
				<div class="flex items-center justify-center ml-5">
					<img class="w-[85%] mt-2" src="/assets/img/noPostDayView.svg" alt="">
				</div>
			</div>
		</div>
	</div>
</div>
<app-loader [isLoading]="isLoading"/>
